import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

// const passwordValidation = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const FormPasswordUpdateSchema = yup.object({
  currentPassword: yup.string().required('account_settings:please_provide_current_password').default(''),
  newPassword: yup
    .string()
    .required('account_settings:please_provide_new_password')
    // .matches(passwordValidation, 'Your new password format is not valid')
    .notOneOf([yup.ref('currentPassword')], 'account_settings:new_password_must_be_different_from_current')
    .min(8, 'account_settings:password_must_contain_eight_or_more_characters')
    .matches(/(?=.*[a-z])/, 'account_settings:password_must_contain_one_lower_case')
    .matches(/(?=.*[A-Z])/, 'account_settings:password_must_contain_one_upper_case')
    .matches(/(?=.*\d)/, 'account_settings:password_must_contain_one_number')
    .matches(/(?=.*\W)/, 'account_settings:password_must_contain_one_special_character')
    .default(''),
  confirmPassword: yup
    .string()
    .required('account_settings:please_confirm_new_password')
    .oneOf([yup.ref('newPassword')], 'account_settings:password_do_not_match')
    .default(''),
});

export const useFormPasswordUpdate = () => {
  return useForm({ resolver: yupResolver(FormPasswordUpdateSchema) });
};
